import { render, staticRenderFns } from "./ShipmentBuilderModule.vue?vue&type=template&id=b5815594&"
import script from "./ShipmentBuilderModule.vue?vue&type=script&lang=js&"
export * from "./ShipmentBuilderModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports